(function () {
  var REVIEW_URL =
    'https://www.google.com/search?hl=en-GB&gl=uk&q=Premier+Polytunnels,+Factory+Ln,+Pasture+Ln,+Barrowford,+Nelson+BB9+6ES&ludocid=9105556718473117440&lsig=AB86z5WlVS7jD2tdsH_3ZZiE20Lf#lrd=0x487b8ddb3a2da297:0x7e5d6f9796c2ff00,1';

  document.querySelectorAll('.shopify-app-block').forEach(function (block) {
    if (!block.querySelector('.reputon-google-reviews-widget')) return;
    if (block.closest('a')) return;

    var link = document.createElement('a');
    link.href = REVIEW_URL;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.className = 'product__price-review-link';
    link.setAttribute('aria-label', 'Read our Google reviews');

    block.parentNode.insertBefore(link, block);
    link.appendChild(block);
  });
})();
